import { darken, alpha, lighten } from '@mui/material/styles';

const styles = theme => ({
  leftTable: {
    height: '100%',
  },
  fixedTable: {
    position: 'sticky',
    left: 0,
    borderRight: `1px solid
    ${
      theme.palette.mode === 'light'
        ? lighten(alpha(theme.palette.divider, 1), 0.88)
        : darken(alpha(theme.palette.divider, 1), 0.68)
    }`,
    background: theme.palette.common.white,
    zIndex: 3,
    width: 'auto',
  },
  mainTable: {
    width: 'auto',
    flex: '1 0 0',
    height: '100%',
  },
  aheadOfTime: {
    color: 'green',
  },
  delayed: {
    color: 'red',
  },
  tableHead: {
    height: theme.typography.pxToRem(70),
  },
  selectedRow: {
    background: 'red',
  },
  totalRow: {
    background: 'grey',
    position: 'sticky',
    bottom: 0,
  },
  flightNumberCell: {
    '&:hover': {
      cursor: 'pointer',
    },
  },
});

export default styles;
